export default __webpack_public_path__ + "static/lineto-circular-bold-f817e60da2bacff0143ba1db823eb252.woff2";